import {IForecastType} from '../../api/api.types';
import IOrganizationApi from '../../api/organization-api.service';
import * as moment from 'moment';

export default class SeasonalFrequencyManagerController {
	static $inject = ['organizationApi', '$mdDialog', '$translate', '$window'];

	private forecastTypes: IForecastType[] = [];
	private seasonalFrequencySettings: IForecastType = {
		issueDate: new Date,
		targetPeriodStart: new Date,
		targetPeriodEnd: new Date,
		name: '',
		frequency: 'seasonal'
	};
	private isSettingsEditorVisible: boolean = false;
	private isEditMode: boolean = false;
	private editableFrequencyIndex: number;
	private isInsideOrgSetupWizard: boolean = true;

	onSeasonalFrequencyChange:(callbackArgs:{
    seasonalFrequencies:IForecastType[]}) => void;

    isDisabled: boolean;

	constructor (
		private organizationApi: IOrganizationApi,
		private $mdDialog: ng.material.IDialogService,
		private $translate:ng.translate.ITranslateService,
		private $window: ng.IWindowService
	) {
		if (typeof this.isDisabled === 'undefined') {
			this.isDisabled = false;
		}
	}

	private onAddFrequency($event: MouseEvent) {
		this.isSettingsEditorVisible = true;
	}

	private onSaveClick() {
		if (this.isEditMode) {
			this.forecastTypes[this.editableFrequencyIndex] = this.seasonalFrequencySettings;
		} else {
			this.forecastTypes.push(this.seasonalFrequencySettings);
		}
		this.notifyChange();
		this.resetFrequencySettings();
		this.isSettingsEditorVisible = false;
		this.isEditMode = false;
	}

	private onCancelClick() {
		this.resetFrequencySettings();
		this.isSettingsEditorVisible = false;
		this.isEditMode = false;
	}

	private onEditFrequency($event: MouseEvent, frequency: IForecastType, index: number) {
		this.seasonalFrequencySettings = angular.copy(frequency);
		this.isSettingsEditorVisible = true;
		this.isEditMode = true;
		this.editableFrequencyIndex = index;

		this.seasonalFrequencySettings.issueDate = new Date(moment(this.seasonalFrequencySettings.issueDate).format());
      	this.seasonalFrequencySettings.targetPeriodStart = new Date(moment(this.seasonalFrequencySettings.targetPeriodStart).format());
      	this.seasonalFrequencySettings.targetPeriodEnd = new Date(moment(this.seasonalFrequencySettings.targetPeriodEnd).format());
	}

	private resetFrequencySettings() {
		this.seasonalFrequencySettings = {
			issueDate: new Date,
			targetPeriodStart: new Date,
			targetPeriodEnd: new Date,
			name: '',
			frequency: 'seasonal'
		}
	}

	private onDeleteFrequency($event: MouseEvent, index: number) {
		const self = this;
		const currentOrgId = parseInt(this.$window.localStorage.getItem('currentOrgId'), 10);

		if (this.isInsideOrgSetupWizard) {
			this.forecastTypes.splice(index, 1);
		} else {
			let confirm = this.$mdDialog.confirm()
			    .title('')
			    .textContent(this.$translate.instant('DELETE_CONFIRMATION', {item: self.forecastTypes[index].name}))
			    .targetEvent($event)
			    .ok(this.$translate.instant('DELETE'))
			    .cancel(this.$translate.instant('CANCEL'));

			this.$mdDialog.show(confirm).then(() => {
				if (self.forecastTypes[index].id) {
					this.organizationApi.deleteForecastType(currentOrgId, self.forecastTypes[index])
						.then(() => {
							this.forecastTypes.splice(index, 1);
						})
				} else {
					this.forecastTypes.splice(index, 1);
				}
			});
		}
	}

	private notifyChange() {
		this.onSeasonalFrequencyChange({seasonalFrequencies: this.forecastTypes});
	}
}


/** WEBPACK FOOTER **
 ** ./app/hydromet/organization/seasonal-frequency-manager.controller.ts
 **/